export default [
  {
    title: "Top Charts",
    icon: "TrendingUpIcon",
    route: "top-apps-charts",
    resource: "Invoice",
    action: "manage",
  },
];
